import { useState, useCallback } from 'react';
import { Tour } from 'app/models/Tour';

interface UseLockedTourWarningProps {
  tour?: Tour;
  onProceed: (...args: any[]) => void;
}

export const useLockedTourWarning = ({
  tour,
  onProceed,
}: UseLockedTourWarningProps) => {
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [pendingArgs, setPendingArgs] = useState<any[]>([]);

  const checkAndProceed = useCallback(
    (...args: any[]) => {
      if (tour?.locked) {
        setPendingArgs(args);
        setIsWarningOpen(true);
      } else {
        onProceed(...args);
      }
    },
    [tour?.locked, onProceed],
  );

  const handleConfirmProceed = useCallback(() => {
    setIsWarningOpen(false);
    onProceed(...pendingArgs);
    setPendingArgs([]);
  }, [onProceed, pendingArgs]);

  const handleCancelProceed = useCallback(() => {
    setIsWarningOpen(false);
    setPendingArgs([]);
  }, []);

  return {
    isWarningOpen,
    checkAndProceed,
    handleConfirmProceed,
    handleCancelProceed,
  };
};
